<template>
    <div class="certificate">
        <div class="content">
            <div class="top-line">
                <img src="../../assets/images/icon.png" class="icon">
                <div class="search">
                    <img src="../../assets/images/search.png" class="search" @click="searchInfo">
                    <input v-model="searchHash" class="search" placeholder="证书哈希" v-on:keyup.enter="searchInfo">                    
                </div>
            </div>
            <div v-if="isValid">
                <div class="form-centent">
                    <p class="title-line">区块信息</p>
                    <div class="block-form">
                        <ul>
                            <li>
                                <span>区块高度</span>
                                <span>{{form.height}}</span>
                            </li>
                            <li>
                                <span>证书哈希</span>
                                <p class="copy"
                                    v-clipboard:copy="form.hash"
                                    v-clipboard:success="success"
                                    v-clipboard:error="error">复制</p>
                                <div class="hash" v-if="size < 800">
                                    <p>{{form.hash}}</p>
                                </div>
                                <span v-else>{{[form.hash,size]|filterHash}}</span>
                            </li>
                            <li>
                                <span>上链时间</span>
                                <span>{{form.blockTime|fulltime}}</span>
                            </li>
                        </ul>
                    </div>
                    <p class="title-line">证书详情</p>
                    <div class="certificate-form">
                        <ul>
                            <li>
                                <span>发证机构</span>
                                <span>比特大学</span>
                                <div class="college-icon">
                                <img src="../../assets/images/college.png" > 
                                </div>
                            </li>
                            <li>
                                <span>证书类型</span>
                                <span>区块链{{userInfo.type}}</span>
                            </li>
                            <li>
                                <span>证书编号</span>
                                <span>{{userInfo.certificate_no}}</span>
                            </li>
                        </ul>
                    </div>
                    <p class="title-line">学员信息</p>
                    <div class="college-form">
                        <ul>
                            <li>
                                <span>学号</span>
                                <span>{{userInfo.stu_no}}</span>
                            </li>
                            <li>
                                <span>姓名</span>
                                <span>{{userInfo.username}}</span>
                            </li>
                            <li>
                                <span>性别</span>
                                <span>{{userInfo.sex}}</span>
                            </li>
                            <li>
                                <span>生日</span>
                                <span>{{userInfo.birthday|filterYear}}</span>
                                <!-- 去掉年份 -->
                            </li>
                        </ul>
                    </div>
                </div>
                <p class="title-line">证书图片</p>
                <div class="certificate-box">
                    <progressive-img :src="certificatePic" class="lisence"
                    :placeholder="loading" />
                </div>
            </div>
            <div v-else class="tips">
                输入证书哈希检索证书
            </div>
        </div>
    </div>
</template>

<script>
import { myFetch } from '../../assets/js/api.js'
import { Toast,Indicator } from "mint-ui";
import { checkValid } from "../../assets/js/filter.js"
export default {
    data(){
        return{
            searchHash:'',
            addr:'1MS3u3F9K7FqaxU62C5egmdgiMzUhh7YaX', //发证地址
            form:Object,
            certificatePic: '',
            userInfo:'',
            isValid:false,
            loading:require('../../assets/images/loading.png'),
            params:{
                "jsonrpc":"2.0",
                "id":1,
                "method":"Chain33.QueryTransaction",
                "params":[{"hash":''}]
            }
        }
    },
    computed:{
        size(){
            return document.body.clientWidth
        }
    },
    mounted(){
        const hash = this.$route.query.hash ? this.$route.query.hash:this.searchHash
        this.searchHash = hash.trim()
        if ( hash ) {
            this.searchInfo()
        }
    },
    methods:{
        searchInfo(){
            if (this.searchHash.trim() === "") return Toast("请输入证书哈希");
            else{
                Indicator.open("查询中...")
                this.params.params[0].hash = this.searchHash
                this.$chain33Rpc.queryTransaction(this.searchHash).then((data)=>{
                // myFetch(this.params,'https://mainnode.bityuan.com:8801').then((data)=>{
                    if(data.error===null){
                        this.userInfo = checkValid(data,this.addr)
                        console.log(this.userInfo)
                        if(typeof(this.userInfo)==='object'){
                            this.isValid = true
                            this.form = data.result
                            this.form.hash = this.searchHash
                            this.searchHash = ''
                            this.$router.push(`/certificate.html?hash=${this.form.hash}`)
                            let num = {"certificateNo":this.userInfo.certificate_no}
                            myFetch(num,'https://mainnet.bityuan.com/338090/certificate/get-img').then(data => {
                                if(data.status===200){
                                    let imgsrc = data.res.data.img
                                    if ( location.protocol  === 'https:' && /^http:\/\/114\.215\.100\.111:9001/.test(imgsrc) ) {
                                        // 替换成https
                                        imgsrc = imgsrc.replace('http://114.215.100.111:9001', 'https://mainnet.bityuan.com/339001')
                                    }
                                    this.certificatePic = imgsrc
                                }else{
                                    Toast('证书图片获取失败')
                                }
                            }).catch(()=>{
                                Toast('证书图片获取失败')
                            })
                        }else{
                            this.searchHash = ''
                            this.isValid = false
                            Toast(this.userInfo)
                        }
                    }else{
                        Toast('输入哈希错误')
                    }
                    Indicator.close()
                }).catch(()=>{
                    Indicator.close()
                })
            }
        },
        success(){
            Toast("复制成功");
        },
        error(){
            Toast("复制失败");
        }
    }
}
</script>

<style lang="scss">
.certificate{
    max-width: 1000px;
    min-height: 100vh;
    margin: 0 auto;
    background: #fff;
    ul,li{ padding:0;margin:0;list-style:none}
    .content{
        padding: 4vw;
        .title-line{
            height:50px;
            font-size:16px;
            font-weight:600;
            color:rgba(51,51,51,1);
            line-height:50px;
            padding-left: 5px;
            margin: 10px 0 0 0;
        }
        .top-line{
            .icon{
                width: 200px;
            }
            .search{
                -webkit-appearance: none;
                height: 39px;
                line-height: 39px;
                position: relative;
                display: flex;
                align-items: center;
            }
            .search:focus {
                outline:none;
            }
            div.search{
                margin-top: 3vw
            }
            img.search{
                z-index: 10;
                position: absolute;
                height: 20px;
                left: 15px;;
            }
            input.search{
                width: 100%;
                padding: 0 30px 0 45px;
                border:none;
                background:rgba(248,248,250,1);
                border-radius:20px;
                font-size: 14px;
            }
        }
        .form-centent{
            margin-top: 10px;
            ul li{
                height: 50px;
                line-height: 50px;
                border:1px solid rgba(217,217,217,1);
                border-bottom: none;
                color: #666666;
                padding: 0 10px;
                .college-icon{
                    height: 50px;
                    float: right;
                    display: flex;
                    align-items: center;
                    img{
                        width: 70%;
                    }
                }
                .copy{
                    margin: 0 0 0 10px;
                    float: right;
                    color: #5361FF;
                    cursor: pointer;
                }
                span:nth-of-type(2){
                    float: right;
                }
            }
            ul li:last-child{
                border-bottom: 1px solid rgba(217,217,217,1);
            }
	        .hash{
	        	width: 50%;
                display: inline-block;
	        	height: 50px;
	        	background: #fff;
	        	overflow-x: auto;
                float: right;
	        	p{
	        		white-space: nowrap;  /*强制span不换行*/
	        		// overflow-x: scroll;
	        		color: #5D6187;
	        		font-size: 14px;
                    margin:0;
	        	}
	        }
        }
        .certificate-box{
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            margin:10px 0 50px;
            .lisence{
                max-width: 100%;
            }
            .progressive-image-wrapper{
                padding-bottom: 70%!important;
            }
        }        
    }
}
.tips{
    margin-top: 100px;
    text-align: center;
    color: #666666;
}
</style>


